import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleBedUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <path
          d="M39.91 29.5H16.1c-1.16 0-2.09.93-2.09 2.09v8.1c0 .52.41.93.93.93h1.18a.93.93 0 00.93-.92v-3h21.92v3c0 .51.42.92.93.92h1.18a.93.93 0 00.93-.92v-8.11c0-1.16-.93-2.09-2.09-2.09zM17.5 18h21c.83 0 1.5.67 1.5 1.5V28H16v-8.5c0-.83.67-1.5 1.5-1.5z"
          fill="#FFF"
        />
        <path d="M21 23.3h14a1 1 0 011 1v5H20v-5a1 1 0 011-1z" fill="#CCC" />
      </g>
    </svg>
  );
}

SvgPicCircleBedUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleBedUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleBedUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
